import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Users, Archive, MapPin, FileText, Copy } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
import { useWorkspace } from '../contexts/WorkspaceContext';
export function Newsletters() {
  const {
    newsletters,
    forms,
    duplicateNewsletter
  } = useWorkspace();
  const getFormName = (formId?: number) => {
    if (!formId) return '-';
    return forms.find(f => f.id === formId)?.name || 'Unknown Form';
  };
  return <div className="space-y-6" data-id="element-1471">
      <div className="flex items-center justify-between" data-id="element-1472">
        <div data-id="element-1473">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1474">
            Newsletters & Lists
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-1475">
            Manage audience lists for your campaigns.
          </p>
        </div>
        <Link to="/newsletters/new" className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700" data-id="element-1476">
          <Plus className="h-4 w-4" data-id="element-1477" />
          Create Newsletter
        </Link>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1478">
        {newsletters.length === 0 ? <div className="p-12 text-center" data-id="element-1479">
            <Users className="mx-auto h-12 w-12 text-gray-400" data-id="element-1480" />
            <h3 className="mt-2 text-sm font-semibold text-gray-900" data-id="element-1481">
              No newsletters found
            </h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-1482">
              Create your first newsletter list to start collecting subscribers.
            </p>
          </div> : <table className="min-w-full divide-y divide-gray-200" data-id="element-1483">
            <thead className="bg-gray-50" data-id="element-1484">
              <tr data-id="element-1485">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1486">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1487">
                  Signup Form
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1488">
                  Sub-Region
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1489">
                  Subscribers
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1490">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1491">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1492">
              {newsletters.map(newsletter => <tr key={newsletter.id} className="hover:bg-gray-50" data-id="element-1493">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1494">
                    <div className="text-sm font-medium text-gray-900" data-id="element-1495">
                      {newsletter.name}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-1496">
                      {newsletter.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1497">
                    {newsletter.formId ? <span className="inline-flex items-center gap-1 text-xs text-gray-600" data-id="element-1498">
                        <FileText className="h-3 w-3" data-id="element-1499" />
                        {getFormName(newsletter.formId)}
                      </span> : <span className="text-xs text-gray-400" data-id="element-1500">
                        No form linked
                      </span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1501">
                    {newsletter.subRegion ? <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800" data-id="element-1502">
                        <MapPin className="h-3 w-3" data-id="element-1503" />
                        {newsletter.subRegion}
                      </span> : <span className="text-xs text-gray-400" data-id="element-1504">Team-wide</span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1505">
                    {newsletter.subscriberCount.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1506">
                    <StatusBadge status={newsletter.status} data-id="element-1507" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1508">
                    <div className="flex items-center justify-end gap-3" data-id="element-1509">
                      <button onClick={() => duplicateNewsletter(newsletter.id)} className="text-gray-400 hover:text-blue-600" title="Duplicate" data-id="element-1510">
                        <Copy className="h-4 w-4" data-id="element-1511" />
                      </button>
                      <button className="text-gray-400 hover:text-gray-600" title="Archive" data-id="element-1512">
                        <Archive className="h-4 w-4" data-id="element-1513" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>}
      </div>
    </div>;
}